import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Primitives";

const PARAS = [
  "Kevin was my pit bull — my little nugget. My mom is a veterinarian, so the moment he wasn't acting normal he was in her clinic, and his blood was on its way to a lab.",
  "I helped drain a large dog bowl of dark fluid from around his lungs. He felt better that day. The next day he had to be put down, before the bloodwork even came back.",
  "Out of grief, and with whatever information was available to me, I stumbled into oncology research, computer science, bioinformatics and structural biology.",
  "These tools were built to be my own personal research tools. They, and the platform, have been rebuilt from scratch more than once. Turns out I might have a knack for this — and Morphogenesis is what they grew into.",
];

export const Founder = () => (
  <section id="founder" data-testid="founder-section" className="relative py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid lg:grid-cols-[0.85fr_1.15fr] gap-12 lg:gap-20 items-center">
      <Reveal>
        <figure className="relative">
          <div className="relative overflow-hidden rounded-xl border border-[var(--line)] aspect-[4/5] bg-[var(--surface-2)]">
            <motion.img
              src="/michael-kevin.jpg"
              alt="Michael Varman with his pit bull Kevin"
              data-testid="founder-photo"
              loading="lazy"
              initial={{ scale: 1.08 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
              className="h-full w-full object-cover object-[50%_35%]"
            />
          </div>
          <figcaption className="mt-3 flex items-center justify-between font-mono text-xs text-[var(--muted)]">
            <span>Michael &amp; Kevin</span>
            <span className="flex items-center gap-2"><span className="h-2 w-2 rounded-full bg-[var(--amber)]" />in memory</span>
          </figcaption>
        </figure>
      </Reveal>
      <div>
        <Reveal>
          <Eyebrow>Why this exists</Eyebrow>
          <h2 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[0.95]">Built because of <span className="text-[var(--amber)] italic">Kevin.</span></h2>
        </Reveal>
        <div className="mt-10 space-y-5 border-l-2 border-[var(--teal)] pl-6">
          {PARAS.map((p, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <p className={`text-base md:text-lg leading-relaxed ${i === 0 ? "text-[var(--text)]" : "text-[var(--muted)]"}`}>{p}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p data-testid="founder-signature" className="mt-8 pl-6 font-display text-xl font-bold">— Michael Varman <span className="ml-2 font-mono text-xs font-normal text-[var(--muted)]">creator, Morphogenesis</span></p>
        </Reveal>
      </div>
    </div>
  </section>
);
